import { ProductImageRendition } from "@omni/types/api/product/shared/enums/productImageRendition.enum";
import { Media } from "@omni/types/api/shared/bff/media.model";
import { cn } from "@omni/utils/styles";

import { Image } from "@/components/Product/ProductImage/imageWrapper/image/image.component";
import { DamImage } from "@/utils/dam.utils";
import { EmptyImages } from "@/utils/enums";

type Props = {
    title: string | undefined;
    medias: null | Array<Media>;
    isEcoChequesAccepted: boolean;
    rendition?: ProductImageRendition;
    className?: string;
    lazyLoad?: boolean;
    parentFit?: boolean;
};

const ProductImage = ({
    title,
    medias,
    isEcoChequesAccepted,
    rendition,
    className,
    lazyLoad = false,
    parentFit = false
}: Props) => {
    return (
        <div className={cn("tw:relative")}>
            {isEcoChequesAccepted && (
                <img
                    className={cn(
                        "tw:inline-block tw:h-6 tw:absolute tw:top-0 tw:right-0"
                    )}
                    src={DamImage.icon.label.eco()}
                    alt={"ecocheques"}
                />
            )}
            {medias && (
                <Image
                    className={cn(
                        "tw:block tw:w-full tw:h-auto tw:my-0 tw:mx-auto",
                        className
                    )}
                    medias={medias}
                    altText={title}
                    defaultImageUrl={EmptyImages.Size_146_109}
                    rendition={rendition}
                    lazyLoad={lazyLoad}
                    parentFit={parentFit}
                />
            )}
        </div>
    );
};

export { ProductImage };
